import { HttpClient } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';
import { SettingsService } from './shared/services';
import { AuthModule, LogLevel, OidcConfigService, OidcSecurityService } from 'angular-auth-oidc-client';
import { IServerSettings } from './shared/models';
import { AuthenticationService } from './shared/services/authentication.service';

export function configureAuth(oidcConfigService: OidcConfigService, httpClient: HttpClient, settingsService: SettingsService,  authenticationService: AuthenticationService) {


  const setupAction$ = httpClient
    .get<IServerSettings>('/api/Settings/GetServerSettings')
    .pipe(
      map((customConfig) => {
        settingsService.serverSettings = customConfig;           

        return {
          stsServer: customConfig.IdentityServiceUrl,
          authWellknownEndpoint: `${customConfig.IdentityServiceUrl}/.well-known/openid-configuration`,
          redirectUrl: `${window.location.origin}/`,
          clientId: 'SingleSourceAngularApp',
          scope: 'openid profile email offline_access IdentityServiceApi SingleSourceApi ApiGateway',
          postLogoutRedirectUri: `${window.location.origin}/home`,
          responseType: 'code',
          triggerAuthorizationResultEvent: true,
          startCheckSession: true,
          silentRenew: true,
          renewTimeBeforeTokenExpiresInSeconds: 60,
          useRefreshToken: true,
          maxIdTokenIatOffsetAllowedInSeconds: 90,
          issValidationOff: false,
          autoUserinfo: true,
          postLoginRoute: '/home',
          forbiddenRoute: '/forbidden',
          unauthorizedRoute: '/unauthorized',
          logLevel: LogLevel.Error,
          customParams: {
            prompt: 'select_account', // login, consent
          }
        };
      }),
      switchMap((config) => oidcConfigService.withConfig(config))
  );

  return () => setupAction$.toPromise();

}

@NgModule({
  imports: [AuthModule.forRoot()],
  providers: [
    OidcSecurityService,
    OidcConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: configureAuth,
      deps: [OidcConfigService, HttpClient, SettingsService, AuthenticationService],
      multi: true,
    },
  ],
  exports: [AuthModule],
})
export class AuthConfigModule {}
